import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { MenuItemType } from '@utils/types'
import { WContainer, Button } from '@components/atoms'
import styles from './ArticoliCorrelati.module.sass'
import { ArticoloCard } from '@components/molecules'

interface Props {
  title?: string
  news?: any[] // NewsNode
  className?: string
}

const ArticoliCorrelati = (props: Props) => {
  const { title = undefined, news = [], className = '' } = props

  return news?.length ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={`${styles.layout}`}>
          {!!title && <h2 className={styles.title}>{title}</h2>}
          <div className={`${styles.slider}`}>
            <Swiper
              slidesPerView={1.1}
              spaceBetween={24}
              modules={[A11y, Navigation, Pagination]}
              navigation
              pagination={{ clickable: true, type: 'progressbar' }}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                },
              }}
              className="swiper--bottomNav"
            >
              {news.map((x) => (
                <SwiperSlide key={x.pk}>
                  <ArticoloCard news={x} className={styles.item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default ArticoliCorrelati
